import type { DeepPartial } from '@luna/utils-ts';

import type { SavingsConfig } from '../ProductsConfig';
import { settingsDetails } from './settings-details-config/RO';

export const savings: DeepPartial<SavingsConfig> = {
    useDisposableInsteadOfBalance: true,
    associatedCards: {
        enabled: false,
    },
    statements: {
        showMultiDownloadCard: true,
        showNewCustomStatementCard: true,
    },
    cancellation: {
        enabled: true,
        immediatelyRedirectToOverviewAfterClosing: true,
        signing: {
            showTargetAccountInfo: true,
            showCancelledAccountInfo: true,
        },
        focusPage: {
            errorPageTitle: 'account.scheduledTermDepositCancelation.stripeErrorTitle',
            successPageTitle: 'account.details.services.cancellation.step1.modalHeadline',
            signingPageTitle: 'account.details.services.cancellation.step1.modalHeadline',
            optionsPageTitle: 'account.details.services.cancellation.step1.modalHeadline',
        },
        successMessage: 'account.details.services.cancellation.signing.success',
    },
    settingsDetails,
    newTransfer: {
        sideMenuLabel: 'savings.main.newWithdrawal',
    },
    layout: {
        productInfo: {
            showDisposableAndBalanceAmounts: true,
        },
    },
};
